import { Component } from '@angular/core';
import {
  Event,
  NavigationCancel,
  NavigationEnd,
  NavigationError,
  NavigationStart,
  Router,
  ActivatedRoute
} from '@angular/router';
import { ConfigService } from './shared/config.service';
import { FormDataService } from './shared/form-data.service';
import { DeviceDetectorService } from 'ngx-device-detector';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'easy-claim';
  showSpinner: boolean;
  loading = false;
  contentDetail: any;
  imagePath: any;
  phoneNumber:any;
  showPhoneNoDiv: boolean;
  footerWelcomeNote: any;
  organisationUrl: any;
  hasOrganisationUrl: boolean;
  deviceInfo = null; 
  dateYear: string; 

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private formDataService: FormDataService,
    private configService: ConfigService,
    private deviceService: DeviceDetectorService) {
    this.contentDetail = this.configService.config.Data.contentDetail;
    this.imagePath = this.configService.config.Data.images.OrgLogoBase64String;
    this.phoneNumber = this.configService.config.Data.contentDetail.PhoneNumber.replace(/\s/g, "");
    this.showPhoneNoDiv = this.configService.config.Data.contentDetail.PhoneNumber.trim() == "" ? false : true;
    this.footerWelcomeNote = this.configService.config.Data.footer_welcome_note;
    this.organisationUrl = this.configService.config.Data.organisation_url;
    this.hasOrganisationUrl = this.organisationUrl == "" ? false : true;
   
    /*
    this.router.events.subscribe((event: Event) => {
      switch (true) {
        case event instanceof NavigationStart: {
          this.loading = true;
          break;
        }

        case event instanceof NavigationEnd:
        case event instanceof NavigationCancel:
        case event instanceof NavigationError: {
          this.loading = false;
          break;
        }
        default: {
          break;
        }
      }
    });
    */
  }

  ngOnInit(){
    
    this.formDataService.setTimeStampType("p1start");
    this.formDataService.setTimeStampDateTime(new Date().toUTCString());    

    this.deviceInfo = this.deviceService.getDeviceInfo();
    this.formDataService.setBrowserName(this.deviceInfo.browser);
    this.formDataService.setDeviceName(this.deviceInfo.device);
    this.formDataService.setOSVersion(this.deviceInfo.os_version);

    this.dateYear = new Date().getFullYear().toString();

    const http$ = this.formDataService.startEcAnalytics();
    http$.subscribe(res => {
     
    }, err => {
      console.log(err);
      
    });
  }
}
